import { defineComponent as _defineComponent } from 'vue'
import BasicButton from '@/ui-components/BasicButton.vue';
import { getCurrentInstance, inject, ref, Ref } from 'vue';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { useInternationalOffersTracking } from '../tracking';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import Provider from '@/interfaces/provider';


export default /*#__PURE__*/_defineComponent({
  __name: 'OffersDropdown',
  setup(__props) {

const dropDown = ref<{ $el: HTMLElement }>();
const searchPackages = inject<Ref<Provider[]>>('searchPackages', ref([]));
const { trackInternationalOffers } = useInternationalOffersTracking({ title: null });

const instance = getCurrentInstance();
async function openDropDown() {
	trackInternationalOffers('streamingServiceDropdown');

	const { popoverController } = await import('@/ionic.loader');
	// Create a click event object
	const clickEvent = new MouseEvent('click', {
		bubbles: true,
		cancelable: true,
		view: window,
	});
	Object.defineProperty(clickEvent, 'target', { value: dropDown.value?.$el, writable: false });
	const popover = await popoverController.create({
		cssClass: 'search-list__pop-over',
		component: () => import('@/features/international-offers/components/ProviderSearchList.vue'),
		componentProps: {
			parent: instance?.proxy,
			propsData: { searchPackages: searchPackages?.value },
		},
		event: clickEvent,
	});
	await popover.present();
	trackInternationalOffers('serviceModalOpened');

	popover.onDidDismiss().then(() => {
		const packageContexts = searchPackages.value.map(item =>
			TrackingHelper.getPackageContext(item.packageId, item.technicalName)
		);
		trackInternationalOffers('serviceModalClosed', null, packageContexts);
	});
}

return { __sfc: true,dropDown, searchPackages, trackInternationalOffers, instance, openDropDown, BasicButton, faChevronDown }
}

})